"use client";

import { useEffect } from "react";
import publishEventToSDK from "./publish-event-to-sdk";

const useOnLoadPublisher = (component: string) => {
  useEffect(() => {
    const publish = () =>
      publishEventToSDK({ topic: "contentLoaded", data: { component } });
    document.fonts.ready.then(publish);
  }, [component]);
};

export default useOnLoadPublisher;
